import type { TrackerProvider, TrackEvent } from '../types';

function isTrackingEnabled(): boolean {
  return (
    import.meta.env.MODE === 'production' ||
    import.meta.env.VITE_ENABLE_TRACKER === 'true'
  );
}

export const ga4Provider: TrackerProvider = {
  name: 'ga4',
  track: (event: TrackEvent) => {
    if (!isTrackingEnabled() || !window.gtag) return;
    window.gtag('event', event.eventAction, {
      event_category: event.eventCategory,
      event_label: event.eventLabel,
      screen_name: event.screenName,
      event_description: event.eventDescription,
      ...event.payload,
    });
  },
  setUser: userId => {
    if (!window.gtag) return;
    window.gtag('set', { user_id: userId ?? '' });
  },
  screen: (screenName, payload) => {
    if (!window.gtag) return;
    window.gtag('event', 'screen_view', {
      screen_name: screenName,
      ...payload,
    });
  },
};
